module.exports = __webpack_public_path__ + "img/microplastics-4-mobile.ecedfd5f.png";